import React from "react";
import parse from "html-react-parser";
import { AiOutlineQuestionCircle } from "react-icons/ai";

import { Explanation, QuestionMark } from "./styles";

const Question = ({ explanationMessage, image }) => {
	return (
		<QuestionMark>
			<AiOutlineQuestionCircle size={18} />
			<Explanation>
				{explanationMessage && parse(explanationMessage)}
				{image && <img src={image} alt="" />}
			</Explanation>
		</QuestionMark>
	);
};

export { Question };
